
import React from 'react';
import { useIsMobile } from '../../hooks/use-mobile';

interface MainLayoutProps {
  children: React.ReactNode;
  isChiapasActive: boolean;
  isHidalgoActive: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, isChiapasActive, isHidalgoActive }) => {
  const getBackgroundClass = () => {
    if (isChiapasActive) {
      return 'bg-gradient-to-b from-purple-50 to-white';
    } else if (isHidalgoActive) {
      return 'bg-gradient-to-b from-orange-50 to-white';
    }
    return 'bg-gradient-to-b from-jireh-light to-white';
  };

  return (
    <div className="flex flex-col h-screen">
      <main className="flex-1 overflow-hidden relative">
        <div className={`absolute inset-0 transition-colors duration-500 ${getBackgroundClass()}`}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
